import {Fragment,useState,type ReactNode} from 'react';
import {documentState,staffStatus} from '@myfm/domain';
import {ResponsiveTable,ResponsiveTableRow} from '../ui/ResponsiveTable';
import {StatusBadge} from '../ui/StatusBadge';
import {Icon} from '../ui/Icon';
import {formatDateOnly} from '../dates';
import type {DocumentSummary} from '../ui/document-register';

export function DocumentRegisterTable({rows,renderDocument}:{rows:DocumentSummary[];renderDocument:(row:DocumentSummary)=>ReactNode}){
 const [expanded,setExpanded]=useState<string>();
 return <div className="data-table__scroller" role="region" aria-label="Document records" tabIndex={0}>
  <ResponsiveTable className="data-table document-register-table document-register-table--compact">
   <caption className="data-table__caption"><span className="sr-only">Documents</span></caption>
   <thead><tr><th scope="col">Document</th><th scope="col">Type</th><th scope="col">Building</th><th scope="col">Renewal</th><th scope="col">Review state</th><th scope="col">Issuer</th><th scope="col"><span className="sr-only">Record details</span></th></tr></thead>
   <tbody>{rows.map(row=>{
    const open=expanded===row.id,state=documentState(row),attention=['Expired','Expiring soon'].includes(row.expiry_state),detailsId='document-row-details-'+row.id;
    return <Fragment key={row.id}><ResponsiveTableRow>
     <th scope="row">{renderDocument(row)}</th>
     <td>{row.document_type_name}</td>
     <td title={row.buildings?.map(item=>item.name).join(' · ')}>{row.buildings?.length?row.buildings.length>1?row.buildings[0]!.name+` +${row.buildings.length-1}`:row.buildings[0]!.name:'Not supplied'}</td>
     <td><span className={attention?'document-renewal-attention':undefined} aria-label={attention?staffStatus(row.expiry_state).label+': '+formatDateOnly(row.expiry_date,'Not recorded'):undefined}>
      {formatDateOnly(row.expiry_date,'Not recorded')}{attention&&<Icon name="triangle-alert"/>}
     </span></td>
     <td><StatusBadge text={row.is_management_agreement_rendering?'Controlled Agreement PDF':state.checked}/></td>
     <td>{row.issuer_name||'Not recorded'}</td>
     <td><button type="button" className="document-row-toggle secondary" aria-label={(open?'Hide details of ':'Details of ')+row.title} aria-expanded={open} aria-controls={detailsId}
      onClick={()=>setExpanded(open?undefined:row.id)}><Icon name={open?'chevron-down':'chevron-right'}/></button></td>
    </ResponsiveTableRow>
    {open&&<ResponsiveTableRow><td colSpan={7}><section id={detailsId} aria-label={'Recorded information for '+row.title} className="document-register-row-details">
     <dl className="document-register-row-facts">
      <div><dt>Document reference</dt><dd>{row.document_number}</dd></div>
      <div><dt>Original uploaded name</dt><dd>{row.original_file_name||row.file_name||'Not supplied'}</dd></div>
      <div><dt>Classification</dt><dd>{row.category_name} · {row.document_type_name}</dd></div>
      <div><dt>Building relationships</dt><dd>{row.buildings?.map(item=>item.name).join(' · ')||'Not supplied'}</dd></div>
      <div><dt>Recorded by</dt><dd>{row.created_by_name||'Not recorded'}</dd></div>
      <div><dt>Record / validity / visibility</dt><dd>{state.record} · {state.validity} · {row.sensitivity}</dd></div>
      <div><dt>Inspection date</dt><dd>{formatDateOnly(row.inspection_date,'Not recorded')}</dd></div>
      <div><dt>Effective date</dt><dd>{formatDateOnly(row.effective_date,'Not recorded')}</dd></div>
      <div><dt>Review date</dt><dd>{formatDateOnly(row.review_date,'Not recorded')}</dd></div>
     </dl>
    </section></td></ResponsiveTableRow>}</Fragment>;
   })}</tbody>
  </ResponsiveTable>
 </div>;
}
